const l = {
  name: "WakeFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 10H11V3L13 3V10Z" fill="currentColor"/>
<path d="M7.41409 9L4.21988 5.80579L2.80566 7.22L5.99988 10.4142L7.41409 9Z" fill="currentColor"/>
<path d="M21.1941 7.22L17.9999 10.4142L16.5857 9L19.7799 5.80579L21.1941 7.22Z" fill="currentColor"/>
<path d="M3 13C1.34315 13 0 14.3431 0 16L0 18C0 19.6569 1.34315 21 3 21L21 21C22.6569 21 24 19.6569 24 18L24 16C24 14.3431 22.6569 13 21 13L3 13ZM2 16C2 15.4477 2.44772 15 3 15L21 15C21.5523 15 22 15.4477 22 16L22 18C22 18.5523 21.5523 19 21 19L3 19C2.44772 19 2 18.5523 2 18L2 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as WakeFilled
};
